import { Color } from '../../../../../../utils/theme/types/color'

export const useStyles = (color: Color) => ({

  containerItems: {
    boxShadow: `0 0 3px ${color.color13}`,
    padding: 3,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    '& .MuiGrid-root': {
      flexDirection: 'column',
    },
  },
  optionsAdd:(disable:boolean) => ({
    width: '40px',
    '& .MuiIconButton-root': {
      color: disable ? color.color32 : color.color4,
      padding: 0,
      '& .MuiSvgIcon-root': {
        fontSize: '40px',
      },
    },
  }),
  containerChildren: {
    width: '100%', 
    display: 'flex', 
    gap: 2, 
    alignItems: 'center'
  },
  children: { 
    flex: 1, 
    minWidth: 0 
  }
})
